// libraries
import React, { useEffect, useContext, useState } from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

// queries

// components
import ContentLayoutContext from 'components/layouts/ContentLayoutContextProvider'
import Loading from 'components/generic/Loading'

// helpers and utils
import IFrameComponent from 'components/generic/embeds/IFrameComponent.jsx'
import { useGetMetabaseUrlQuery } from 'gen/rtk-openapi'

const CustomReportBuilderContainer = () => {
  const { yardId } = useSelector(state => state.auth)
  const contentContext = useContext(ContentLayoutContext)
  const [embedUrl, setEmbedUrl] = useState(null)
  const { inOrgMode } = useSelector(state => state.ui)

  const reportBuilder = [
    {
      name: 'Custom Report Builder',
      auth: 'DEMO',
      embedId: 'oE3AaqlAOq',
      orgLevelEmbedId: 'zOVxbqrYDm',
    },
    {
      name: 'Custom Report Builder',
      auth: 'USER',
      embedId: '', // populate in case we separate demo versus prod
    },
  ]

  const customParams = { reportType: 'EXPLO-REPORT-BUILDER' }
  const { data: mbUrlData } = useGetMetabaseUrlQuery(
    {
      reportId: inOrgMode ? reportBuilder[0].orgLevelEmbedId : reportBuilder[0].embedId,
      customParams: JSON.stringify(customParams),
    },
    { skip: !yardId },
  )
  useEffect(() => {
    if (mbUrlData?.iframeUrl) setEmbedUrl(mbUrlData?.iframeUrl)
  }, [mbUrlData])

  useEffect(() => {
    contentContext.setContainerTitle('Custom Reports')
  }, [])

  return (
    <Box style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      {embedUrl ? <IFrameComponent title="ReportBuilder" src={embedUrl} /> : <Loading localized />}
    </Box>
  )
}

export default CustomReportBuilderContainer
